import { api } from "@/api";

export async function getArticulosStockPorDeposito(articuloIds: string[], depositoId: string): Promise<Record<string, number>> {
    if (articuloIds.length === 0) return {};
    const response = await api.post("articulos/stock-por-deposito", { articuloIds, depositoId });
    return response.data;
}
